// cookingTips.js

// Helper function to get the correct language for Belgian language codes
export const getTranslationLanguage = (language) => {
    if (language === 'befr' || language === 'be-fr') return 'french';
    if (language === 'benl' || language === 'be-nl') return 'nederlands';
    if (language === 'bh-ar' || language === 'bahrain-arabic') return 'arabic';
    if (language === 'bh-en' || language === 'bahrain-english') return 'english';
    if (language === 'uae-ar' || language === 'uae-arabic') return 'arabic';
    if (language === 'uae-en' || language === 'uae-english') return 'english';
    if (language === 'sa-ar' || language === 'sa-arabic') return 'arabic';
    if (language === 'sa-en' || language === 'sa-english') return 'english';
    if (language === 'kw-ar' || language === 'kw-arabic') return 'arabic';
    if (language === 'kw-en' || language === 'kw-english') return 'english';
    if (language === 'qa-ar' || language === 'qa-arabic') return 'arabic';
    if (language === 'qa-en' || language === 'qa-english') return 'english';
    if (language === 'om-ar' || language === 'om-arabic') return 'arabic';
    if (language === 'om-en' || language === 'om-english') return 'english';
    if (language === 'iq-ar' || language === 'iq-arabic') return 'arabic';
    if (language === 'iq-en' || language === 'iq-english') return 'english';
    if (language === 'jo-ar' || language === 'jo-arabic') return 'arabic';
    if (language === 'jo-en' || language === 'jo-english') return 'english';
    if (language === 'lb-ar' || language === 'lb-arabic') return 'arabic';
    if (language === 'lb-en' || language === 'lb-english') return 'english';
    if (language === 'sy-ar' || language === 'sy-arabic') return 'arabic';
    if (language === 'sy-en' || language === 'sy-english') return 'english';
    if (language === 'ps-ar' || language === 'ps-arabic') return 'arabic';
    if (language === 'ps-en' || language === 'ps-english') return 'english';
    if (language === 'ye-ar' || language === 'ye-arabic') return 'arabic';
    if (language === 'ye-en' || language === 'ye-english') return 'english';
    if (language === 'eg-ar' || language === 'eg-arabic') return 'arabic';
    if (language === 'eg-en' || language === 'eg-english') return 'english';
    if (language === 'pl-pl') return 'polish';
    if (language === 'cyprus' || language === 'cy' || language === 'el-cy') return 'greek';
    if (language === 'norwegian') return 'norwegian';
    if (language === 'da' || language === 'da-dk' || language === 'dansk' || language === 'danish') return 'danish';
    if (language === 'sv' || language === 'sv-se' || language === 'svenska' || language === 'swedish') return 'swedish';
    if (language === 'sl' || language === 'sl-si' || language === 'slovenian') return 'slovenian';
    if (language === 'el' || language === 'el-gr' || language === 'greek') return 'greek';
    return language;
};

// Function to get a random cooking tip for a specific language
export const getRandomCookingTip = (language) => {
    const translationLanguage = getTranslationLanguage(language);
    // Fallback to English if language not found
    const tips = cookingTips[translationLanguage] || cookingTips['english'];
    const randomIndex = Math.floor(Math.random() * tips.length);
    return tips[randomIndex];
};

const cookingTips = {
    portuguese: [
        "Sempre pré-aqueça o forno antes de assar.",
        "Use uma faca afiada para cortes mais precisos e seguros.",
        "Tempere sua comida durante o preparo, não apenas no final.",
        "Deixe a carne descansar após o cozimento para reter seus sucos.",
        "Mise en place: prepare todos os ingredientes antes de começar a cozinhar.",
        "Não encha demais a panela ao refogar para evitar o cozimento a vapor.",
        "Use água fria para começar quando ferver batatas.",
        "Adicione sal à água do macarrão para melhor sabor.",
        "Invista em um bom conjunto de panelas.",
        "Mantenha suas facas afiadas para cortes mais fáceis e seguros.",
        "Use ervas frescas para melhor sabor em seus pratos.",
        "Não abra a porta do forno com muita frequência durante o cozimento.",
        "Seque a carne antes de dourar para obter uma crosta melhor.",
        "Guarde a água do macarrão para molhos - adiciona sabor e ajuda a engrossar.",
        "Deixe os ovos chegarem à temperatura ambiente antes de assar.",
        "Use um termômetro de carne para garantir o cozimento adequado.",
        "Não adicione óleo à água do macarrão - isso impede que o molho grude.",
        "Vire a carne apenas uma vez ao grelhar para melhores resultados.",
        "Torre as especiarias para realçar seu sabor antes de usar.",
        "Use uma balança de cozinha para medidas mais precisas ao assar.",
        "Não lave cogumelos - escove-os para limpar.",
        "Esfrie a massa de biscoitos antes de assar para melhor textura.",
        "Use sal kosher para cozinhar - é mais fácil de pegar e controlar.",
        "Deixe a massa de panqueca descansar para panquecas mais fofas.",
        "Quebre ovos em uma superfície plana para evitar fragmentos de casca.",
        "Mantenha cebolas na geladeira antes de cortar para reduzir as lágrimas.",
        "Use manteiga em temperatura ambiente para assar, a menos que especificado o contrário.",
        "Não enxágue o macarrão após cozinhar - isso remove o amido que ajuda o molho a aderir.",
        "Rale a casca de frutas cítricas antes de espremer o suco.",
        "Use ovos mais velhos para descascar melhor quando cozidos.",
        "Coloque a carne em salmoura antes de cozinhar para resultados mais suculentos.",
        "Não pressione hambúrgueres enquanto grelha - isso libera os sucos.",
        "Use um pouco de vinagre ao escalfar ovos para ajudar a manter a forma.",
        "Torre nozes antes de usar em receitas para realçar o sabor.",
        "Deixe a manteiga e os ovos chegarem à temperatura ambiente para assar.",
        "Use uma pedra de pizza para obter crostas mais crocantes.",
        "Não encha demais a assadeira ao assar legumes.",
        "Guarde cascas de parmesão para adicionar sabor a sopas e ensopados.",
        "Use uma colher de sorvete para biscoitos ou almôndegas de tamanho uniforme.",
        "Enxágue o arroz antes de cozinhar para remover o excesso de amido.",
        "Use uma colher de pau para evitar que a água do macarrão ferva e transborde.",
        "Congele o vinho restante em bandejas de cubos de gelo para uso futuro no cozimento.",
        "Deixe as camadas do bolo esfriarem completamente antes de colocar a cobertura.",
        "Use uma faca serrilhada para fatiar pão e tomates.",
        "Mergulhe espetos de madeira em água antes de grelhar para evitar que queimem.",
        "Use uma toalha de papel úmida sob a tábua de corte para evitar que escorregue.",
        "Rale a manteiga ao fazer massa de torta para resultados mais folhados."
    ],
    english: [
        "Always preheat your oven before baking.",
        "Use a sharp knife for more precise and safer cutting.",
        "Season your food as you go, not just at the end.",
        "Let meat rest after cooking to retain its juices.",
        "Mise en place: prepare all ingredients before you start cooking.",
        "Don't overcrowd the pan when sautéing to avoid steaming.",
        "Use cold water to start when boiling potatoes.",
        "Add salt to pasta water for better flavor.",
        "Invest in a good set of pots and pans.",
        "Keep your knives sharp for easier and safer cutting.",
        "Use fresh herbs for better flavor in your dishes.",
        "Don't open the oven door too often while baking.",
        "Pat meat dry before searing for a better crust.",
        "Save pasta water for sauces - it adds flavor and helps thicken.",
        "Let eggs come to room temperature before baking.",
        "Use a meat thermometer to ensure proper cooking.",
        "Don't add oil to pasta water - it prevents sauce from sticking.",
        "Flip meat only once when grilling for better results.",
        "Toast spices to enhance their flavor before using.",
        "Use a kitchen scale for more accurate baking measurements.",
        "Don't wash mushrooms - brush them clean instead.",
        "Chill cookie dough before baking for better texture.",
        "Use kosher salt for cooking - it's easier to pinch and control.",
        "Rest pancake batter for fluffier pancakes.",
        "Crack eggs on a flat surface to avoid shell fragments.",
        "Keep onions in the fridge before cutting to reduce tears.",
        "Use room temperature butter for baking unless specified otherwise.",
        "Don't rinse pasta after cooking - it removes starch that helps sauce stick.",
        "Zest citrus fruits before juicing them.",
        "Use older eggs for better peeling when hard-boiling.",
        "Brine meat before cooking for juicier results.",
        "Don't press down on burgers while grilling - it releases juices.",
        "Use a splash of vinegar when poaching eggs to help them hold shape.",
        "Toast nuts before using in recipes for enhanced flavor.",
        "Let butter and eggs come to room temperature for baking.",
        "Use a pizza stone for crispier crusts.",
        "Don't crowd the pan when roasting vegetables.",
        "Save Parmesan rinds to add flavor to soups and stews.",
        "Use an ice cream scoop for evenly sized cookies or meatballs.",
        "Rinse rice before cooking to remove excess starch.",
        "Use a wooden spoon to prevent pasta water from boiling over.",
        "Freeze leftover wine in ice cube trays for future use in cooking.",
        "Let cake layers cool completely before frosting.",
        "Use a serrated knife for slicing bread and tomatoes.",
        "Soak wooden skewers before grilling to prevent burning.",
        "Use a damp paper towel under your cutting board to prevent slipping.",
        "Grate butter when making pie crust for flakier results."
    ],
    nederlands: [
        "Verwarm de oven altijd voor bij het bakken.",
        "Gebruik een scherp mes voor nauwkeuriger en veiliger snijden.",
        "Breng je eten tijdens het koken op smaak, niet alleen op het einde.",
        "Laat vlees rusten na het koken om de sappen vast te houden.",
        "Mise en place: bereid alle ingrediënten voordat je begint met koken.",
        "Vul de pan niet te vol bij het sauteren om stomen te voorkomen.",
        "Gebruik koud water om aardappelen te koken.",
        "Voeg zout toe aan het pastawater voor een betere smaak.",
        "Investeer in een goede set potten en pannen.",
        "Houd je messen scherp voor gemakkelijker en veiliger snijden.",
        "Gebruik verse kruiden voor een betere smaak in je gerechten.",
        "Open de oven niet te vaak tijdens het bakken.",
        "Dep vlees droog voordat je het dichtschroeit voor een betere korst.",
        "Bewaar pastawater voor sauzen - het voegt smaak toe en maakt dikker.",
        "Laat eieren op kamertemperatuur komen voor het bakken.",
        "Gebruik een vleesthermometer om de juiste gaarheid te garanderen.",
        "Voeg geen olie toe aan het pastawater - dit voorkomt dat de saus blijft plakken.",
        "Draai vlees maar één keer om tijdens het grillen voor betere resultaten.",
        "Rooster specerijen om hun smaak te versterken voordat je ze gebruikt.",
        "Gebruik een keukenweegschaal voor nauwkeurigere bakresultaten.",
        "Was champignons niet - borstel ze schoon in plaats daarvan.",
        "Koel koekjesdeeg voor het bakken voor een betere textuur.",
        "Gebruik koosjer zout bij het koken - het is gemakkelijker te knijpen en te controleren.",
        "Laat pannenkoekenbeslag rusten voor luchtigere pannenkoeken.",
        "Tik eieren op een plat oppervlak om schilfragmenten te vermijden.",
        "Bewaar uien in de koelkast voordat je ze snijdt om tranen te verminderen.",
        "Gebruik boter op kamertemperatuur voor het bakken, tenzij anders vermeld.",
        "Spoel pasta niet af na het koken - dit verwijdert zetmeel dat helpt bij het binden van saus.",
        "Rasp citrusvruchten voordat je ze uitperst.",
        "Gebruik oudere eieren voor beter pellen bij het hardkoken.",
        "Laat vlees weken in pekel voor sappiger resultaten.",
        "Druk niet op hamburgers tijdens het grillen - dit laat sappen vrij.",
        "Gebruik een scheutje azijn bij het pocheren van eieren om de vorm te behouden.",
        "Rooster noten voordat je ze in recepten gebruikt voor extra smaak.",
        "Laat boter en eieren op kamertemperatuur komen voor het bakken.",
        "Gebruik een pizzasteen voor knapperigere bodems.",
        "Vul de pan niet te vol bij het roosteren van groenten.",
        "Bewaar Parmezaankorsten om smaak toe te voegen aan soepen en stoofschotels.",
        "Gebruik een ijslepel voor gelijkmatig gevormde koekjes of gehaktballen.",
        "Spoel rijst af voor het koken om overtollig zetmeel te verwijderen.",
        "Gebruik een houten lepel om te voorkomen dat het pastawater overkookt.",
        "Vries restjes wijn in ijsblokjesvormen in voor later gebruik in gerechten.",
        "Laat cakelagen volledig afkoelen voordat je ze glazuurt.",
        "Use a serrated knife for slicing bread and tomatoes.",
        "Weiche Holzspieße vor dem Grillen ein, um ein Verbrennen zu verhindern.",
        "Lege ein feuchtes Papiertuch unter dein Schneidebrett, um ein Verrutschen zu verhindern.",
        "Rasp boter als je een taartbodem maakt voor een luchtiger resultaat."
    ],
    deutsch: [
        "Heize den Ofen immer vor dem Backen vor.",
        "Benutze ein scharfes Messer für präzisere und sicherere Schnitte.",
        "Würze dein Essen während des Kochens, nicht nur am Ende.",
        "Lasse das Fleisch nach dem Kochen ruhen, um den Saft zu bewahren.",
        "Mise en Place: Bereite alle Zutaten vor, bevor du mit dem Kochen beginnst.",
        "Überfülle die Pfanne nicht beim Anbraten, um Dampf zu vermeiden.",
        "Verwende kaltes Wasser, um Kartoffeln zu kochen.",
        "Füge Salz zum Nudelwasser hinzu, um den Geschmack zu verbessern.",
        "Investiere in ein gutes Set Töpfe und Pfannen.",
        "Halte deine Messer scharf für einfacheres und sichereres Schneiden.",
        "Verwende frische Kräuter für einen besseren Geschmack in deinen Gerichten.",
        "Öffne die Ofentür nicht zu oft während des Backens.",
        "Tupfe das Fleisch trocken, bevor du es anbrätst, um eine bessere Kruste zu erhalten.",
        "Bewahre das Nudelwasser für Soßen auf - es fügt Geschmack hinzu und hilft, sie zu verdicken.",
        "Lasse Eier vor dem Backen auf Zimmertemperatur kommen.",
        "Verwende ein Fleischthermometer, um die richtige Garstufe zu gewährleisten.",
        "Füge kein Öl zum Nudelwasser hinzu - es verhindert, dass die Soße haftet.",
        "Drehe das Fleisch beim Grillen nur einmal, um bessere Ergebnisse zu erzielen.",
        "Röste Gewürze, um ihren Geschmack zu intensivieren, bevor du sie verwendest.",
        "Verwende eine Küchenwaage für genauere Backergebnisse.",
        "Wasche Pilze nicht - bürste sie stattdessen sauber.",
        "Kühle den Keksteig vor dem Backen, um eine bessere Textur zu erhalten.",
        "Verwende koscheres Salz beim Kochen - es ist einfacher zu greifen und zu dosieren.",
        "Lasse den Pfannkuchenteig ruhen, um fluffigere Pfannkuchen zu erhalten.",
        "Schlage Eier auf einer flachen Oberfläche auf, um Schalenfragmente zu vermeiden.",
        "Lagere Zwiebeln im Kühlschrank, bevor du sie schneidest, um Tränen zu reduzieren.",
        "Verwende Butter bei Zimmertemperatur für das Backen, es sei denn, es wird anders angegeben.",
        "Spüle die Pasta nach dem Kochen nicht ab - dies entfernt die Stärke, die hilft, die Soße zu binden.",
        "Reibe Zitrusfrüchte, bevor du sie auspresst.",
        "Verwende ältere Eier für besseres Schälen beim Hartkochen.",
        "Salze das Fleisch vor dem Kochen ein, um saftigere Ergebnisse zu erzielen.",
        "Drücke nicht auf die Burger beim Grillen - es setzt Säfte frei.",
        "Verwende einen Spritzer Essig beim Pochieren von Eiern, um ihnen zu helfen, ihre Form zu behalten.",
        "Röste Nüsse, bevor du sie in Rezepten verwendest, um den Geschmack zu verbessern.",
        "Lasse Butter und Eier vor dem Backen auf Zimmertemperatur kommen.",
        "Verwende einen Pizzastein, um knusprigere Böden zu erhalten.",
        "Überfülle die Pfanne nicht beim Rösten von Gemüse.",
        "Bewahre Parmesanrinden auf, um Suppen und Eintöpfen Geschmack zu verleihen.",
        "Verwende einen Eisportionierer, um gleich große Kekse oder Fleischbällchen zu formen.",
        "Spüle Reis vor dem Kochen ab, um überschüssige Stärke zu entfernen.",
        "Verwende einen Holzlöffel, um zu verhindern, dass das Nudelwasser überkocht.",
        "Friere übriggebliebenen Wein in Eiswürfelformen ein, um ihn später in Rezepten zu verwenden.",
        "Lasse die Kuchenschichten vollständig abkühlen, bevor du sie glasierst.",
        "Verwende ein gezacktes Messer, um Brot und Tomaten zu schneiden.",
        "Weiche Holzspieße vor dem Grillen ein, um ein Verbrennen zu verhindern.",
        "Lege ein feuchtes Papiertuch unter dein Schneidebrett, um ein Verrutschen zu verhindern.",
        "Reibe Butter für Tortenböden, um ein flockigeres Ergebnis zu erzielen."
    ],
    spanish: [
        "Siempre precalienta el horno antes de hornear.",
        "Usa un cuchillo afilado para cortar de manera más precisa y segura.",
        "Sazona tu comida mientras cocinas, no solo al final.",
        "Deja reposar la carne después de cocinarla para que retenga sus jugos.",
        "Mise en place: prepara todos los ingredientes antes de empezar a cocinar.",
        "No llenes demasiado la sartén al saltear para evitar que se cocine al vapor.",
        "Usa agua fría al hervir papas.",
        "Agrega sal al agua de la pasta para darle mejor sabor.",
        "Invierte en un buen juego de ollas y sartenes.",
        "Mantén tus cuchillos afilados para un corte más fácil y seguro.",
        "Usa hierbas frescas para mejorar el sabor de tus platos.",
        "No abras la puerta del horno con demasiada frecuencia mientras horneas.",
        "Seca la carne antes de dorarla para obtener una mejor costra.",
        "Guarda el agua de la pasta para las salsas: agrega sabor y ayuda a espesar.",
        "Deja que los huevos alcancen la temperatura ambiente antes de hornear.",
        "Usa un termómetro para carne para asegurarte de que esté bien cocida.",
        "No agregues aceite al agua de la pasta, ya que evita que la salsa se adhiera.",
        "Gira la carne solo una vez al asarla para obtener mejores resultados.",
        "Tosta las especias para intensificar su sabor antes de usarlas.",
        "Usa una báscula de cocina para medir con mayor precisión al hornear.",
        "No laves los champiñones, límpialos con un cepillo.",
        "Refrigera la masa de galletas antes de hornear para obtener una mejor textura.",
        "Usa sal kosher al cocinar: es más fácil de pellizcar y controlar.",
        "Deja reposar la masa de los panqueques para que sean más esponjosos.",
        "Rompe los huevos sobre una superficie plana para evitar fragmentos de cáscara.",
        "Refrigera las cebollas antes de cortarlas para reducir las lágrimas.",
        "Usa mantequilla a temperatura ambiente para hornear, a menos que se indique lo contrario.",
        "No enjuagues la pasta después de cocinarla, ya que elimina el almidón que ayuda a que la salsa se adhiera.",
        "Ralla los cítricos antes de exprimirlos.",
        "Usa huevos más viejos para que se pelen mejor cuando los hiervas.",
        "Deja la carne en salmuera antes de cocinarla para obtener resultados más jugosos.",
        "No presiones las hamburguesas mientras las asas, ya que libera sus jugos.",
        "Agrega un chorrito de vinagre al escalfar huevos para ayudarlos a mantener su forma.",
        "Tosta las nueces antes de usarlas en recetas para mejorar su sabor.",
        "Deja que la mantequilla y los huevos alcancen la temperatura ambiente antes de hornear.",
        "Usa una piedra para pizza para obtener bases más crujientes.",
        "No llenes demasiado la sartén al asar verduras.",
        "Guarda las cortezas de parmesano para añadir sabor a sopas y guisos.",
        "Usa una cuchara para helado para formar galletas o albóndigas del mismo tamaño.",
        "Enjuaga el arroz antes de cocinarlo para eliminar el exceso de almidón.",
        "Usa una cuchara de madera para evitar que el agua de la pasta hierva.",
        "Congela el vino sobrante en bandejas de cubitos de hielo para usarlo en futuras recetas.",
        "Deja que las capas de pastel se enfríen completamente antes de glasearlas.",
        "Usa un cuchillo serrado para cortar pan y tomates.",
        "Remoja los pinchos de madera antes de asarlos para evitar que se quemen.",
        "Usa una toalla de papel húmeda debajo de tu tabla de cortar para evitar que se deslice.",
        "Ralla la mantequilla para obtener una masa de pastel más ligera."
    ],
    french: [
        "Préchauffez toujours votre four avant de cuire.",
        "Utilisez un couteau bien aiguisé pour une coupe plus précise et plus sûre.",
        "Assaisonnez vos aliments au fur et à mesure que vous cuisinez, pas seulement à la fin.",
        "Laissez reposer la viande après la cuisson pour conserver ses jus.",
        "Mise en place : préparez tous les ingrédients avant de commencer à cuisiner.",
        "Ne surchargez pas la poêle lors de la cuisson pour éviter la vapeur.",
        "Utilisez de l'eau froide pour démarrer la cuisson des pommes de terre.",
        "Ajoutez du sel à l'eau des pâtes pour un meilleur goût.",
        "Investissez dans un bon ensemble de casseroles et poêles.",
        "Gardez vos couteaux bien aiguisés pour une coupe plus facile et plus sûre.",
        "Utilisez des herbes fraîches pour de meilleures saveurs dans vos plats.",
        "N'ouvrez pas la porte du four trop souvent pendant la cuisson.",
        "Épongez la viande avant de la saisir pour obtenir une meilleure croûte.",
        "Gardez l'eau des pâtes pour les sauces - cela ajoute de la saveur et aide à épaissir.",
        "Laissez les œufs revenir à température ambiante avant de cuire.",
        "Utilisez un thermomètre à viande pour assurer une cuisson appropriée.",
        "N'ajoutez pas d'huile à l'eau des pâtes - cela empêche la sauce d'adhérer.",
        "Retournez la viande seulement une fois lors du grillage pour de meilleurs résultats.",
        "Faites griller les épices pour améliorer leur saveur avant utilisation.",
        "Utilisez une balance de cuisine pour des mesures plus précises lors de la cuisson.",
        "Ne lavez pas les champignons - brossez-les à la place.",
        "Réfrigérez la pâte à biscuits avant la cuisson pour une meilleure texture.",
        "Utilisez du sel casher pour la cuisine - il est plus facile à pincer et à contrôler.",
        "Laissez reposer la pâte à crêpes pour des crêpes plus moelleuses.",
        "Cassez les œufs sur une surface plane pour éviter les fragments de coquille.",
        "Réfrigérez les oignons avant de les couper pour réduire les larmes.",
        "Utilisez du beurre à température ambiante pour la cuisson, sauf indication contraire.",
        "Ne rincez pas les pâtes après la cuisson - cela enlève l'amidon qui aide la sauce à adhérer.",
        "Zestez les agrumes avant de les presser.",
        "Utilisez des œufs plus vieux pour un meilleur pelage lors de la cuisson dure.",
        "Faites mariner la viande avant la cuisson pour des résultats plus juteux.",
        "Ne pressez pas les hamburgers pendant le grillage - cela libère les jus.",
        "Ajoutez une touche de vinaigre lors du pochage des œufs pour aider à maintenir leur forme.",
        "Faites griller les noix avant de les utiliser dans les recettes pour améliorer la saveur.",
        "Laissez le beurre et les œufs revenir à température ambiante avant de cuire.",
        "Utilisez une pierre à pizza pour des croûtes plus croustillantes.",
        "Ne surchargez pas la poêle lors de la torréfaction des légumes.",
        "Gardez les croûtes de parmesan pour ajouter de la saveur aux soupes et ragoûts.",
        "Utilisez une cuillère à glace pour des cookies ou boulettes de viande de taille égale.",
        "Rincez le riz avant de le cuire pour éliminer l'excès d'amidon.",
        "Utilisez une cuillère en bois pour empêcher l'eau des pâtes de déborder.",
        "Congelez le vin restant dans des bacs à glaçons pour l'utiliser plus tard dans la cuisine.",
        "Laissez les couches de gâteau refroidir complètement avant de les glacer.",
        "Utilisez un couteau dentelé pour trancher le pain et les tomates.",
        "Faites tremper les brochettes en bois avant de griller pour éviter qu'elles ne brûlent.",
        "Utilisez une serviette en papier humide sous votre planche à découper pour éviter qu'elle ne glisse.",
        "Râpez le beurre lorsque vous faites une croûte de tarte pour obtenir un résultat plus feuilleté."
    ],
    serbian: [
        "Uvek prethodno zagrejte rernu pre pečenja.",
        "Koristite oštar nož za preciznije i bezbednije sečenje.",
        "Začinite hranu tokom kuvanja, ne samo na kraju.",
        "Ostavite meso da odmori nakon kuvanja kako bi zadržalo sokove.",
        "Mise en place: pripremite sve sastojke pre nego što počnete sa kuvanjem.",
        "Ne pretrpavajte tiganj prilikom dinstanja da biste izbegli stvaranje pare.",
        "Koristite hladnu vodu za početak kuvanja krompira.",
        "Dodajte so u vodu za testeninu za bolji ukus.",
        "Uložite u dobar set lonaca i tiganja.",
        "Održavajte noževe oštrim za lakše i bezbednije sečenje."
    ],
    romanian: [
        "Preîncălziți întotdeauna cuptorul înainte de a coace.",
        "Folosiți un cuțit ascuțit pentru tăiere mai precisă și mai sigură.",
        "Condimentați mâncarea în timp ce gătiți, nu doar la sfârșit.",
        "Lăsați carnea să se odihnească după gătire pentru a-și păstra sucurile.",
        "Mise en place: pregătiți toate ingredientele înainte de a începe să gătiți.",
        "Nu aglomerați tigaia când prăjiți pentru a evita aburirea.",
        "Folosiți apă rece când fierbeți cartofi.",
        "Adăugați sare în apa de paste pentru un gust mai bun.",
        "Investiți într-un set bun de oale și tigăi.",
        "Păstrați cuțitele ascuțite pentru tăiere mai ușoară și mai sigură."
    ],
    arabic: [
        "دائماً قم بتسخين الفرن قبل الخبز.",
        "استخدم سكيناً حاداً للقطع الأكثر دقة والأمان.",
        "تبّل طعامك أثناء الطهي، وليس في النهاية فقط.",
        "دع اللحم يرتاح بعد الطهي للاحتفاظ بعصارته.",
        "Mise en place: حضّر جميع المكونات قبل أن تبدأ في الطهي.",
        "لا تملأ المقلاة كثيراً عند التحريك لتجنب التبخير.",
        "استخدم ماء بارداً للبدء عند غليان البطاطس.",
        "أضف ملحاً إلى ماء المعكرونة للحصول على طعم أفضل.",
        "استثمر في مجموعة جيدة من القدر والمقلاة.",
        "حافظ على سكاكينك حادة للقطع الأسهل والأكثر أماناً.",
        "استخدم الأعشاب الطازجة للحصول على طعم أفضل في أطباقك.",
        "لا تفتح باب الفرن كثيراً أثناء الخبز.",
        "جفف اللحم قبل التحمير للحصول على قشرة أفضل.",
        "احفظ ماء المعكرونة للصلصات - يضيف نكهة ويساعد في التقديم.",
        "دع البيض يصل إلى درجة حرارة الغرفة قبل الخبز.",
        "استخدم ميزان حرارة اللحم لضمان الطهي المناسب.",
        "لا تضف زيتاً إلى ماء المعكرونة - يمنع الصلصة من الالتصاق.",
        "اقلب اللحم مرة واحدة فقط عند الشواء للحصول على نتائج أفضل.",
        "اطبخ التوابل لتعزيز نكهتها قبل الاستخدام.",
        "استخدم ميزان المطبخ لقياسات الخبز الأكثر دقة.",
        "لا تغسل الفطر - امسحه نظيفاً بدلاً من ذلك.",
        "برد عجينة ملفات الكوكيز قبل الخبز للحصول على نسيج أفضل.",
        "استخدم ملح الكوشر عند الطهي - من الأسهل قبضه ومراقبته.",
        "راح عجينة البانكيك للحصول على بانكيك أكثر نعومة.",
        "اكسر البيض على سطح مستوٍ لتجنب شظايا القشرة.",
        "احتفظ بالبصل في الثلاجة قبل القطع لتقليل الدموع.",
        "استخدم الزبدة في درجة حرارة الغرفة للخبز إلا إذا تم تحديد خلاف ذلك.",
        "لا تشطف المعكرونة بعد الطهي - تزيل النشا الذي يساعد الصلصة على الالتصاق.",
        "قشر فواكه الحمضيات قبل عصرها.",
        "استخدم بيضاً أقدم للحصول على قشر أفضل عند الغليان.",
        "نقع اللحم قبل الطهي للحصول على نتائج أكثر عصارة.",
        "لا تضغط على الهامبرغر أثناء الشواء - يطلق العصارة.",
        "أضف رذاذ خل عند سلق البيض لمساعدتهم على الحفاظ على شكلهم.",
        "اطبخ المكسرات قبل استخدامها في الوصفات للحصول على نكهة محسنة.",
        "دع الزبدة والبيض يصلان إلى درجة حرارة الغرفة قبل الخبز.",
        "استخدم حجر البيتزا للحصول على قشر أكثر هشاشة.",
        "لا تملأ المقلاة كثيراً عند شواء الخضروات.",
        "احفظ قشور البارميزان لإضافة نكهة إلى الحساء واليخنات.",
        "استخدم مغرفة الآيس كريم لملفات الكوكيز أو كرات اللحم متساوية الحجم.",
        "اشطف الأرز قبل الطهي لإزالة النشا الزائد.",
        "استخدم ملعقة خشبية لمنع ماء المعكرونة من الغليان الزائد.",
        "جمّد النبيذ المتبقي في صواني مكعبات الثلج للاستخدام المستقبلي في الطهي.",
        "دع طبقات الكعكة تبرد تماماً قبل التزيين.",
        "استخدم سكيناً مسنناً لتقطيع الخبز والطماطم.",
        "انقع أسياخ الخشب قبل الشواء لمنع الحرق.",
        "استخدم منشفة ورقية رطبة تحت لوح القطع لمنع الانزلاق.",
        "رش الزبدة عند صنع قشرة الفطيرة للحصول على نتيجة أكثر رقة."
    ],
    norwegian: [
        "Varm alltid opp ovnen før steking.",
        "Bruk en skarp kniv for mer presis og trygg kutting.",
        "Krydre maten din under tilberedning, ikke bare på slutten.",
        "La kjøttet hvile etter tilberedning for å beholde saftene.",
        "Mise en place: forbered alle ingredienser før du begynner å lage mat.",
        "Ikke fyll pannen for fullt når du steker for å unngå damp.",
        "Bruk kaldt vann når du koker poteter.",
        "Tilsett salt til pastavann for bedre smak.",
        "Invester i et godt sett med gryter og panner.",
        "Hold knivene dine skarpe for lettere og tryggere kutting.",
        "Bruk ferske urter for bedre smak i matrettene dine.",
        "Ikke åpne ovnsdøren for ofte under steking.",
        "Tørk kjøttet før steking for bedre skorpe.",
        "Spar pastavann for sauser - det tilfører smak og hjelper til å tykne.",
        "La eggene komme til romtemperatur før steking.",
        "Bruk et kjøtttermometer for å sikre riktig tilberedning.",
        "Ikke tilsett olje til pastavann - det forhindrer at sausen fester seg.",
        "Snu kjøttet bare én gang når du griller for bedre resultater.",
        "Rist krydder for å forbedre smaken før bruk.",
        "Bruk en kjøkkenvekt for mer nøyaktige bakemålinger.",
        "Ikke vask sopp - børst dem rene i stedet.",
        "Kjol kakebatteret før steking for bedre tekstur.",
        "Bruk kosher salt til matlaging - det er lettere å ta og kontrollere.",
        "La pannekakebatteret hvile for luftigere pannekaker.",
        "Knus egg på en flat overflate for å unngå skallfragmenter.",
        "Hold løk i kjøleskapet før kutting for å redusere tårer.",
        "Bruk smør på romtemperatur til baking, med mindre annet er spesifisert.",
        "Ikke skyl pasta etter tilberedning - det fjerner stivelse som hjelper sausen å feste seg.",
        "Riv sitrusfrukt før du presser dem.",
        "Bruk eldre egg for bedre skrelling når de hardkokes.",
        "La kjøttet ligge i saltlake før tilberedning for saftigere resultater.",
        "Ikke trykk på hamburgere under grilling - det frigjør saftene.",
        "Bruk en skvett eddik når du poacherer egg for å hjelpe dem å holde formen.",
        "Rist nøtter før bruk i oppskrifter for forbedret smak.",
        "La smør og egg komme til romtemperatur før baking.",
        "Bruk en pizzastein for sprøere bunn.",
        "Ikke fyll pannen for fullt når du roasterer grønnsaker.",
        "Spar parmesanskall for å tilføye smak til supper og gryteretter.",
        "Bruk en iskremeskje for jevnstørrelse kjeks eller kjøttboller.",
        "Skyl ris før tilberedning for å fjerne overflødig stivelse.",
        "Bruk en tresleiv for å forhindre at pastavannet koker over.",
        "Fryse resterende vin i isbrikkeformer for fremtidig bruk i matlaging.",
        "La kakelagene kjøle helt ned før glasering.",
        "Bruk en tagget kniv for å skjære brød og tomater.",
        "Legg trepinner i vann før grilling for å forhindre at de brenner.",
        "Bruk et fuktig papirhåndkle under skjærebrettet for å forhindre skliing.",
        "Riv smør når du lager paideig for mer flakete resultater."
    ],
    danish: [
        "Forvarm altid ovnen før bagning.",
        "Brug en skarp kniv til mere præcis og sikker skæring.",
        "Krydre din mad undervejs, ikke kun til sidst.",
        "Lad kødet hvile efter tilberedning for at bevare safterne.",
        "Mise en place: Forbered alle ingredienser, før du begynder at lave mad.",
        "Overfyld ikke panden, når du sauterer, for at undgå dampning.",
        "Brug koldt vand til at starte, når du koger kartofler.",
        "Tilsæt salt til pastavand for bedre smag.",
        "Invester i et godt sæt gryder og pander.",
        "Hold dine knive skarpe for lettere og sikrere skæring.",
        "Brug friske urter for bedre smag i dine retter.",
        "Åbn ikke ovndøren for ofte under bagning.",
        "Dup kødet tørt før stegning for at få en bedre skorpe.",
        "Gem pastavand til saucer - det tilføjer smag og hjælper med at fortykke.",
        "Lad æg komme til stuetemperatur før bagning.",
        "Brug et kødtermometer for at sikre korrekt tilberedning.",
        "Tilsæt ikke olie til pastavand - det forhindrer saucen i at sætte sig.",
        "Vend kun kødet én gang ved grillning for bedre resultater.",
        "Rist krydderier for at forstærke deres smag, før du bruger dem.",
        "Brug en køkkenvægt til mere præcise bagemålinger.",
        "Vask ikke svampe - børst dem rene i stedet.",
        "Køl småkagedej ned før bagning for bedre tekstur.",
        "Brug kosher-salt til madlavning - det er lettere at tage og kontrollere.",
        "Lad pandekagedejen hvile for luftigere pandekager.",
        "Knæk æg på en flad overflade for at undgå skalfragmenter.",
        "Opbevar løg i køleskabet før skæring for at reducere tårer.",
        "Brug smør ved stuetemperatur til bagning, medmindre andet er angivet.",
        "Skyl ikke pasta efter tilberedning - det fjerner stivelse, der hjælper saucen med at sætte sig.",
        "Riv citrusfrugter, før du presser dem.",
        "Brug ældre æg til bedre skrælning ved hårdkogning.",
        "Læg kødet i saltlage før tilberedning for saftigere resultater.",
        "Tryk ikke ned på burgere under grillning - det frigiver safterne.",
        "Brug et stænk eddike, når du pocherer æg, for at hjælpe dem med at holde formen.",
        "Rist nødder, før du bruger dem i opskrifter, for forbedret smag.",
        "Lad smør og æg komme til stuetemperatur før bagning.",
        "Brug en pizzasten for sprødere skorper.",
        "Overfyld ikke panden ved ristning af grøntsager.",
        "Gem parmesanskorper til at tilføje smag til supper og gryderetter.",
        "Brug en isske til jævnstore småkager eller kødboller.",
        "Skyl ris før tilberedning for at fjerne overskydende stivelse.",
        "Brug en træske til at forhindre pastavand i at koge over.",
        "Frys resterende vin i isterningbakker til fremtidig brug i madlavning.",
        "Lad kagelag køle helt ned, før du glaserer dem.",
        "Brug en takket kniv til at skære brød og tomater.",
        "Læg træspyd i blød, før du griller, for at forhindre forbrænding.",
        "Brug et fugtigt papirhåndklæde under dit skærebræt for at forhindre glidning.",
        "Riv smør, når du laver tærtedej, for mere flaket resultat."
    ],
    swedish: [
        "Förvärm alltid ugnen före bakning.",
        "Använd en vass kniv för mer exakt och säker skärning.",
        "Krydda din mat under tillagningen, inte bara i slutet.",
        "Låt köttet vila efter tillagning för att behålla safterna.",
        "Mise en place: Förbered alla ingredienser innan du börjar laga mat.",
        "Fyll inte pannan för mycket när du fräser för att undvika ångning.",
        "Använd kallt vatten för att börja när du kokar potatis.",
        "Tillsätt salt till pastavattnet för bättre smak.",
        "Investera i en bra uppsättning kastruller och stekpannor.",
        "Håll dina knivar vassa för enklare och säkrare skärning.",
        "Använd färska örter för bättre smak i dina rätter.",
        "Öppna inte ugnsluckan för ofta under bakning.",
        "Torka köttet torrt före stekning för att få en bättre skorpa.",
        "Spara pastavattnet till såser - det tillför smak och hjälper till att tjockna.",
        "Låt ägg komma till rumstemperatur före bakning.",
        "Använd en kötttermometer för att säkerställa korrekt tillagning.",
        "Tillsätt inte olja till pastavattnet - det hindrar såsen från att fästa.",
        "Vänd köttet bara en gång vid grillning för bättre resultat.",
        "Rosta kryddor för att förstärka deras smak innan användning.",
        "Använd en köksvåg för mer exakta bakmätningar.",
        "Tvätta inte svamp - borsta dem rena istället.",
        "Kyl kakdegen före bakning för bättre textur.",
        "Använd kosher-salt för matlagning - det är lättare att ta och kontrollera.",
        "Låt pannkakssmeten vila för fluffigare pannkakor.",
        "Knäck ägg på en plan yta för att undvika skalfragment.",
        "Förvara lök i kylskåpet före skärning för att minska tårar.",
        "Använd smör i rumstemperatur för bakning om inte annat anges.",
        "Skölj inte pasta efter tillagning - det tar bort stärkelse som hjälper såsen att fästa.",
        "Riv citrusskal innan du pressar dem.",
        "Använd äldre ägg för bättre skalning vid hårdkokning.",
        "Lägg köttet i saltlag före tillagning för saftigare resultat.",
        "Tryck inte ner hamburgare under grillning - det frigör safterna.",
        "Använd en skvätt ättika när du pocherar ägg för att hjälpa dem hålla formen.",
        "Rosta nötter innan du använder dem i recept för förbättrad smak.",
        "Låt smör och ägg komma till rumstemperatur före bakning.",
        "Använd en pizzasten för sprödare skorpor.",
        "Fyll inte pannan för mycket vid rostning av grönsaker.",
        "Spara parmesanskal för att tillföra smak till soppor och grytor.",
        "Använd en glasskopa för jämnstora kakor eller köttbullar.",
        "Skölj riset före tillagning för att ta bort överflödig stärkelse.",
        "Använd en träslev för att förhindra pastavattnet från att koka över.",
        "Frys kvarvarande vin i isbitsformar för framtida användning i matlagning.",
        "Låt tårtlager svalna helt innan du glaserar dem.",
        "Använd en tandad kniv för att skära bröd och tomater.",
        "Blötlägg träspett före grillning för att förhindra bränning.",
        "Använd en fuktig pappershandduk under skärbrädan för att förhindra glidning.",
        "Riv smör när du gör pajskal för flakigare resultat."
    ],
    slovenian: [
        "Vedno predgrejte pečico pred pečenjem.",
        "Uporabite oster nož za natančnejše in varnejše rezanje.",
        "Začinite hrano med pripravo, ne le na koncu.",
        "Pustite meso počivati po kuhanju, da ohrani sokove.",
        "Mise en place: pripravite vse sestavine, preden začnete kuhati.",
        "Ne prenapolnite ponve pri praženju, da preprečite parjenje.",
        "Za kuhanje krompirja uporabite hladno vodo.",
        "Dodajte sol v vodo za testenine za boljši okus.",
        "Investirajte v dober komplet loncev in ponev.",
        "Noži naj bodo vedno ostri za lažje in varnejše rezanje.",
        "Uporabite sveže zelišča za boljši okus jedi.",
        "Med pečenjem ne odpirajte prepogosto vrat pečice.",
        "Meso osušite pred praženjem za boljšo skorjico.",
        "Shranite vodo od testenin za omake – doda okus in pomaga zgostiti.",
        "Pred pečenjem pustite jajca, da dosežejo sobno temperaturo.",
        "Uporabite termometer za meso za pravilno pripravo.",
        "Ne dodajajte olja v vodo za testenine – to prepreči oprijem omake.",
        "Meso pri žarjenju obrnite samo enkrat za boljše rezultate.",
        "Popražite začimbe, da ojačate njihov okus pred uporabo.",
        "Uporabite kuhinjsko tehtnico za natančnejše merjenje pri pečenju.",
        "Gob ne perite – raje jih obrišite.",
        "Pred pečenjem ohladite testo za piškote za boljšo teksturo.",
        "Uporabite košer sol za kuhanje – lažje jo je prijeti in odmerjati.",
        "Pustite testo za palačinke počivati za bolj puhaste palačinke.",
        "Jajca razbijte na ravni površini, da preprečite drobce lupine.",
        "Čebulo pred rezanjem shranite v hladilnik, da zmanjšate solzenje.",
        "Za pečenje uporabite maslo sobne temperature, razen če je navedeno drugače.",
        "Testenin po kuhanju ne izpirajte – to odstrani škrob, ki pomaga omaki oprijeti.",
        "Naribajte lupino citrusov, preden jih iztisnete.",
        "Za lažje lupljenje uporabite starejša jajca pri trdem kuhanju.",
        "Meso pred kuhanjem nasolite za sočnejše rezultate.",
        "Hamburgerjev med žarjenjem ne pritiskajte – to sprosti sokove.",
        "Dodajte kapljico kisa pri pochiranju jajc, da jim pomaga ohraniti obliko.",
        "Oreščke pred uporabo v receptih popražite za boljši okus.",
        "Maslo in jajca pustite, da dosežeta sobno temperaturo pred pečenjem.",
        "Uporabite kamen za pico za bolj hrustljavo skorjo.",
        "Ne prenapolnite ponve pri pečenju zelenjave.",
        "Shranite parmezanove skorje za dodajanje okusa v juhe in enolončnice.",
        "Uporabite zajemalko za sladoled za enako velike piškote ali mesne kroglice.",
        "Riž pred kuhanjem sperite, da odstranite odvečni škrob.",
        "Uporabite leseno žlico, da preprečite prekipevanje vode za testenine.",
        "Preostanek vina zamrznite v modelčkih za ledene kocke za kasnejšo uporabo pri kuhanju.",
        "Pred glaziranjem pustite plasti torte, da se popolnoma ohladijo.",
        "Uporabite nazobčan nož za rezanje kruha in paradižnikov.",
        "Lesene nabodalnike pred žarjenjem namočite, da preprečite gorenje.",
        "Pod desko za rezanje položite vlažen papirnat brisačko, da preprečite drsenje.",
        "Maslo naribajte pri pripravi testa za pito za bolj listnato teksturo."
    ],
    greek: [
        "Προθερμαίνετε πάντα τον φούρνο πριν το ψήσιμο.",
        "Χρησιμοποιήστε κοφτερό μαχαίρι για πιο ακριβές και ασφαλέστερο κόψιμο.",
        "Αλατοπιπερώνετε το φαγητό σας κατά το μαγείρεμα, όχι μόνο στο τέλος.",
        "Αφήστε το κρέας να ξεκουραστεί μετά το μαγείρεμα για να κρατήσει τους χυμούς του.",
        "Mise en place: ετοιμάστε όλα τα συστατικά πριν ξεκινήσετε το μαγείρεμα.",
        "Μην γεμίζετε υπερβολικά το τηγάνι όταν σοτάρετε για να αποφύγετε τον ατμό.",
        "Χρησιμοποιήστε κρύο νερό όταν ξεκινάτε το βράσιμο πατατών.",
        "Προσθέστε αλάτι στο νερό των ζυμαρικών για καλύτερη γεύση.",
        "Επενδύστε σε ένα καλό σετ κατσαρολών και τηγανιών.",
        "Κρατήστε τα μαχαίρια σας κοφτερά για ευκολότερο και ασφαλέστερο κόψιμο.",
        "Χρησιμοποιήστε φρέσκα μυρωδικά για καλύτερη γεύση στα πιάτα σας.",
        "Μην ανοίγετε συχνά την πόρτα του φούρνου κατά το ψήσιμο.",
        "Στεγνώστε το κρέας πριν το σοτάρετε για καλύτερη κρούφτα.",
        "Κρατήστε το νερό των ζυμαρικών για σάλτσες - προσθέτει γεύση και βοηθά στο πήξιμο.",
        "Αφήστε τα αυγά να έρθουν σε θερμοκρασία δωματίου πριν το ψήσιμο.",
        "Χρησιμοποιήστε θερμόμετρο κρέατος για σωστό μαγείρεμα.",
        "Μην προσθέτετε λάδι στο νερό των ζυμαρικών - εμποδίζει τη σάλτσα να κολλήσει.",
        "Γυρίστε το κρέας μόνο μία φορά όταν ψήνετε στη σχάρα για καλύτερα αποτελέσματα.",
        "Καβουρδίστε τα μπαχαρικά για να ενισχύσετε τη γεύση τους πριν τη χρήση.",
        "Χρησιμοποιήστε ζυγαριά κουζίνας για πιο ακριβείς μετρήσεις στο ψήσιμο.",
        "Μην πλένετε τα μανιτάρια - καθαρίστε τα με βούρτσα.",
        "Ψύξτε τη ζύμη μπισκότων πριν το ψήσιμο για καλύτερη υφή.",
        "Χρησιμοποιήστε kosher αλάτι στο μαγείρεμα - είναι πιο εύκολο στον έλεγχο.",
        "Αφήστε τη ζύμη τηγανιτών να ξεκουραστεί για πιο αφράτες τηγανίτες.",
        "Σπάστε τα αυγά σε επίπεδη επιφάνεια για να αποφύγετε κομμάτια τσόφλι.",
        "Κρατήστε τα κρεμμύδια στο ψυγείο πριν τα κόψετε για λιγότερα δάκρυα.",
        "Χρησιμοποιήστε βούτυρο σε θερμοκρασία δωματίου για ψήσιμο, εκτός αν αναφέρεται διαφορετικά.",
        "Μην ξεπλένετε τα ζυμαρικά μετά το μαγείρεμα - αφαιρεί το άμυλο που βοηθά τη σάλτσα να κολλήσει.",
        "Αλέστε τη φλούδα των εσπεριδοειδών πριν τα στύψετε.",
        "Χρησιμοποιήστε παλαιότερα αυγά για ευκολότερο ξεφλούδισμα όταν τα βράζετε σφιχτά.",
        "Αλατίστε το κρέας πριν το μαγείρεμα για πιο ζουμερά αποτελέσματα.",
        "Μην πιέζετε τα μπέργκερ στη σχάρα - απελευθερώνει τους χυμούς.",
        "Προσθέστε λίγο ξύδι όταν ποσέρετε αυγά για να κρατήσουν το σχήμα τους.",
        "Καβουρδίστε τους ξηρούς καρπούς πριν τους χρησιμοποιήσετε για ενισχυμένη γεύση.",
        "Αφήστε βούτυρο και αυγά να έρθουν σε θερμοκρασία δωματίου για ψήσιμο.",
        "Χρησιμοποιήστε πέτρα πίτσας για πιο τραγανή κρούστα.",
        "Μην γεμίζετε υπερβολικά το ταψί όταν ψήνετε λαχανικά.",
        "Κρατήστε τις φλούδες παρμεζάνας για να προσθέσετε γεύση σε σούπες και μαγειρευτά.",
        "Χρησιμοποιήστε κουτάλι παγωτού για ομοιόμορφα μπισκότα ή κεφτέδες.",
        "Ξεπλύνετε το ρύζι πριν το μαγείρεμα για να αφαιρέσετε το περιττό άμυλο.",
        "Χρησιμοποιήστε ξύλινη κουτάλα για να μην ξεχειλίσει το νερό των ζυμαρικών.",
        "Καταψύξτε το υπόλοιπο κρασί σε παγοθήκες για μελλοντική χρήση στο μαγείρεμα.",
        "Αφήστε τα στρώματα κέικ να κρυώσουν εντελώς πριν τα γλασάρετε.",
        "Χρησιμοποιήστε οδοντωτό μαχαίρι για κόψιμο ψωμιού και ντομάτας.",
        "Μουσκέψτε ξύλινα σουβλάκια πριν το ψήσιμο για να μην καούν.",
        "Βάλτε υγρό χαρτί κουζίνας κάτω από την επιφάνεια κοπής για να μην γλιστράει.",
        "Τρίψτε βούτυρο όταν φτιάχνετε ζύμη πίτας για πιο φυλλώδη αποτέλεσμα."
    ]
};

export default cookingTips;
